let dictionary = [
  { word: "Carnival", longtext: "iasdcasd", shorttext: "hi" },
  { word: "Carnival", longtext: "helloooo", shorttext: "hi" },
  { word: "Weaon", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "Road", longtext: "iasdcasd", shorttext: "hi" },
  { word: "Carnival", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "Community", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
  { word: "Road", longtext: "iasdcasd", shorttext: "hi" },
  { word: "Carnival", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "Community", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
  { word: "Weapon", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
  { word: "MainLayout", longtext: "helloooo", shorttext: "hi" },
];

export default dictionary;
